module.exports = __webpack_public_path__ + "img/max-file-add--xml.ff1b3f9e.svg";